import { useConfirmDialog } from '@/composables/useConfirmDialog';
import { EIcon } from 'common/enum/misc.enum';
import { useI18n } from 'vue-i18n';

export const useBillingInvoiceCreateConfirm = (): {
  confirmBillingInvoiceCreate: () => Promise<boolean>;
} => {
  const { confirm } = useConfirmDialog();
  const { t } = useI18n();

  const confirmBillingInvoiceCreate = (): Promise<boolean> =>
    confirm({
      title: t('billing.invoicePayment.confirmCreateInvoiceTitle'),
      description: t('billing.invoicePayment.confirmCreateInvoiceDescription'),
      confirmButtonLabel: t('billing.invoicePayment.confirmCreateInvoiceButton'),
      declineButtonLabel: t('billing.invoicePayment.reviewInvoiceAddressButton'),
      theme: 'primary',
      size: 'xl',
      confirmButtonIcon: EIcon.DOCUMENT_CHECK,
      buttonAlignment: 'between',
    });

  return {
    confirmBillingInvoiceCreate,
  };
};
